import Nullstack from 'nullstack';
export default function IconBellSchool({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-bell-school",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "10",
    cy: "10",
    r: "6"
  }), "   ", Nullstack.element("path", {
    d: "M13.5 15h.5a2 2 0 0 1 2 2v1a2 2 0 0 1 -2 2h-8a2 2 0 0 1 -2 -2v-1a2 2 0 0 1 2 -2h.5"
  }), "   ", Nullstack.element("path", {
    d: "M16 17a5.698 5.698 0 0 0 4.467 -7.932l-.467 -1.068"
  }), "   ", Nullstack.element("path", {
    d: "M10 10v.01"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "8",
    r: "1"
  }), " ");
}